import { FormattedMessage } from 'react-intl';
import { Modal } from 'components/atoms/modal';
import { useAppUpgradeConfirmationQuery } from 'queries/app-upgrade-confirmation';

interface AppUpgradeConfirmationProps {
  successCallback?: () => void;
}

export const AppUpgradeConfirmation = ({
  successCallback = () => {
    window.location.reload();
  },
}: AppUpgradeConfirmationProps) => {
  const { data: showUpgradeModal = false } = useAppUpgradeConfirmationQuery();

  return (
    <Modal
      title={<FormattedMessage id="app_upgrade.confirmation" />}
      open={showUpgradeModal}
      onOk={successCallback}
      closable={false}
      cancelButtonProps={{ hidden: true }}
    />
  );
};
